import instagram from '../img/instagram.png';
import gitHub from '../img/github.png';
import linkedin from '../img/linkedin.png';
import stackoverflow from '../img/stack-overflow.png';
import whatsapp from '../img/whatsapp.png';
import gmail from '../img/gmail.png';

export default function Contact(){
    return(
        <div className='social'>
            <a href='https://www.instagram.com/alfeu_x/' target='_blank' rel='noreferrer noopener'>
                <img src={instagram} alt='instagram logo' />
            </a>
            <a href='https://wa.me/258870311075' target='_blank' rel='noreferrer noopener'>
                <img src={whatsapp} alt='whatsapp logo'/>
            </a>
            <a href='mailto: alfeuxirinda@gmail.com?subject=Mail from AlfeuX Web Portifolio' target='_blank' rel='noreferrer noopener'>
                <img src={gmail} alt='gmail logo'/>
            </a>
            <a href='https://www.linkedin.com/in/alfeux' target='_blank' rel='noreferrer noopener'>
                <img src={linkedin} alt='linkedin logo' />
            </a>
            <a href='https://github.com/Hard-007' target='_blank' rel='noreferrer noopener'>
                <img src={gitHub} alt='github logo' />
            </a>
            <a href='https://stackoverflow.com/users/11428142/hard-007' target='_blank' rel='noreferrer noopener'>
                <img src={stackoverflow} alt='stack overflow logo' />
            </a>
        </div>
    );
}